import Vue from "vue";

const firebaseConfig = {
  apiKey: "AIzaSyClxyZ19pNqyFnyb_ivythFig-dkye5Yjk",
  authDomain: "card-slash-limited.firebaseapp.com",
  databaseURL:
    "https://card-slash-limited-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "card-slash-limited",
  storageBucket: "card-slash-limited.appspot.com",
  messagingSenderId: "960252151737",
  appId: "1:960252151737:web:6063c62cf07eb4c158d868",
  measurementId: "G-XBB7HCD59Y",
};

Vue.mixin({
  data: function () {
    return {
      get companyName() {
        return "CARD SLASH LIMITED"; //公司名稱
      },
      get regFormDomain() {
        return "https://cardslash.xyz/";
      },
    };
  },
});

//  溫馨提示：建議使用較淺的顏色
//  歡迎回來的背景顏色
const panelColor = "#e8f2fa";

//  溫馨提示：建議使用較深的顏色
//  側邊欄的背景顏色
const sideBarColor = "#000";

//        /||\
//       / || \
//      |------|
//      |  ||  |
//      |  ||  |
//      |  ||  |
//      |  ||  |
//       \ || /
//  不用理 \||/
//        /||\
//       / || \
export { firebaseConfig, panelColor, sideBarColor };
